export const Hero = () => (
  <section className="relative overflow-hidden bg-gradient-to-b from-teal-50/70 to-white">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-24 top-16 h-72 w-72 rounded-full bg-teal-100/60 blur-3xl"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-24 bottom-0 h-80 w-80 rounded-full bg-teal-200/40 blur-3xl"
    />
    <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-5 pb-20 pt-16 sm:pt-20 lg:grid-cols-2 lg:gap-8 lg:pb-28 lg:pt-24">
      <div className="animate-fade-up">
        <span
          data-testid="hero-badge"
          className="inline-flex items-center gap-2 rounded-full border border-teal-200 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-teal-700"
        >
          <span className="h-2 w-2 rounded-full bg-teal-500" />
          Demnächst für iOS &amp; Android
        </span>
        <h1
          data-testid="hero-headline"
          className="font-display mt-6 text-4xl font-extrabold leading-[1.08] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl"
        >
          Gemeinsam entscheiden.{" "}
          <span className="text-teal-500">Einfach etwas unternehmen.</span>
        </h1>
        <p
          data-testid="hero-subtext"
          className="mt-6 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg"
        >
          Wokivo ist die App für alle, die mit Freunden, Familie oder der
          Gruppe endlich unkompliziert planen wollen: Ideen sammeln, gemeinsam
          abstimmen und direkt etwas unternehmen – ohne endlose
          Chat-Diskussionen.
        </p>
        <div className="mt-8 flex flex-wrap items-center gap-3">
          <a
            href="#appstore"
            data-testid="hero-cta-appstore"
            className="rounded-full bg-teal-500 px-7 py-3.5 text-sm font-extrabold text-white shadow-lg shadow-teal-500/25 transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-teal-600"
          >
            Bald im App Store
          </a>
          <a
            href="#funktionen"
            data-testid="hero-cta-features"
            className="rounded-full border-2 border-teal-500/30 bg-white px-7 py-3.5 text-sm font-extrabold text-teal-700 transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 hover:border-teal-500 hover:bg-teal-50"
          >
            Funktionen entdecken
          </a>
        </div>
      </div>
      <div className="animate-fade-up delay-2 relative mx-auto w-full max-w-xs sm:max-w-sm">
        <div className="absolute inset-6 rounded-full bg-teal-400/25 blur-2xl" aria-hidden="true" />
        <img
          src="/wokivo-logo.png"
          alt="Wokivo App-Icon mit Woki, dem Waschbären"
          data-testid="hero-logo"
          className="animate-float relative w-full rounded-[22%] shadow-2xl shadow-teal-600/25 ring-4 ring-white"
        />
        <p className="mt-5 text-center text-sm font-bold text-teal-700/80">
          Woki freut sich schon auf euch!
        </p>
      </div>
    </div>
  </section>
);
